import { render } from "./RegisterConsentCheckboxes.vue?vue&type=template&id=498a1dc5"
import script from "./RegisterConsentCheckboxes.vue?vue&type=script&lang=js"
export * from "./RegisterConsentCheckboxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__